<template lang="pug">
  div(v-cloak)
    v-layout(row wrap)
      v-flex(xs12)
        v-btn(color="primary" @click="closing" :disabled="isListEmpty || hasTrial || totalRows > 10")
          v-icon save
          span この見積内容で見積書を作成する
        v-btn(flat color="success" @click="previewQuotation" :disabled="isListEmpty || totalRows > 10")
          v-icon picture_as_pdf
          span この内容で見積書をプレビュー
      v-flex(xs12 v-if="isListEmpty || hasTrial")
        span.remarks 保存するには、１件以上の明細登録があることと、未確定の試算がないことが必要です。

      v-flex(xs12 v-if="totalRows > 10")
        v-alert(type="warning" outline value="true")
          p 明細が10件を超えるため、登録できません。一度に追加できる見積は、別枠オプション、値引(0円以外の数値)を含み10件までです。

      v-flex(xs12 md6)
        v-card
          v-card-title.primary
            | 追記事項
          v-card-text
            v-layout(row wrap)
              v-flex(xs12 md6)
                v-text-field(
                  type="text"
                  label="納期"
                  :value="summary.terms"
                  @input="setSummary({'terms': $event})"
                  autocapitalize="off"
                  hide-details
                  )
              v-flex(xs12 md6)
                v-text-field(
                  type="text"
                  label="受渡場所"
                  :value="summary.place"
                  @input="setSummary({'place': $event})"
                  autocapitalize="off"
                  hide-details
                  )
              v-flex(xs12 md6)
                v-text-field(
                  type="text"
                  label="お取引条件"
                  :value="summary.condition"
                  @input="setSummary({'condition': $event})"
                  autocapitalize="off"
                  hide-details
                  )
              v-flex(xs12 md6)
                v-text-field(
                  type="text"
                  label="見積有効期限"
                  :value="summary.expiration"
                  @input="setSummary({'expiration': $event})"
                  autocapitalize="off"
                  hide-details
                  )
              v-flex(xs12)
                v-textarea(
                  type="text"
                  label="通信欄"
                  :value="summary.message"
                  @input="setSummary({'message': $event})"
                  autocapitalize="off"
                  rows="5"
                  hide-details
                  )
        v-card.mt-1
          v-card-title.primary
            | 送料
          v-card-text
            v-layout(row wrap)
              v-flex(xs12 md6 offset-md6)
                v-text-field(
                  type="number"
                  label="送料"
                  :value="summary.delivery_fee"
                  @input="setSummary({'delivery_fee': $event})"
                  ref="delivery_fee"
                  :rules="[rules.required,rules.integer,rules.positive]"
                  autocapitalize="off"
                  suffix="円"
                  )
        v-card.mt-1
          v-card-title.primary
            | 値引
          v-card-text
            v-layout(row wrap)
              v-flex(xs12)
                p.remarks 入力した金額を値引きます。
                p.remarks.red--text 値引は見積書の明細の１件としてカウントし、見積書に印字されます。
                p.remarks 0円の場合は明細にはカウントされず、見積書にも印字されません。
                p.remarks マイナスで入力すると値上げになります。
              v-flex(xs12 md6 offset-md6)
                v-text-field(
                  type="number"
                  label="値引"
                  :value="summary.discount"
                  @input="setSummary({'discount': $event})"
                  ref="discount"
                  :rules="[rules.required,rules.integer]"
                  autocapitalize="off"
                  suffix="円"
                  )

      v-flex(xs12 md6)
        v-layout(row wrap)
          v-flex(xs12 xl8)

            v-card
              v-card-title.grey
                | 最終確認
              v-card-text
                .app-line
                  span.app-line-title 追跡番号
                  span.app-line-text {{order.token}}
                  span.app-line-suffix
                .app-line
                  span.app-line-title
                  span.app-line-text &nbsp;
                  span.app-line-suffix
                .app-line
                  span.app-line-title 基準日
                  span.app-line-text {{prepare.order_date|date}}
                  span.app-line-suffix
                .app-line
                  span.app-line-title 入力日
                  span.app-line-text {{summary.input_date|date}}
                  span.app-line-suffix
                .app-line
                  span.app-line-title 営業担当
                  span.app-line-text
                    span(v-if="summary.seller && summary.seller.id") {{summary.seller.options.sign}}
                  span.app-line-suffix
                .app-line
                  span.app-line-title 業務担当
                  span.app-line-text
                    span(v-if="summary.inputter && summary.inputter.id") {{summary.inputter.options.sign}}
                  span.app-line-suffix
                .app-line
                  span.app-line-title 顧客担当者
                  span.app-line-text
                    span(v-if="summary.customer && summary.customer.id") {{summary.customer.display}}
                  span.app-line-suffix 様
                .app-line
                  span.app-line-title
                  span.app-line-text &nbsp;
                  span.app-line-suffix
                .app-line
                  span.app-line-title 総明細数
                  span.app-line-text {{total_rows|number}}
                  span.app-line-suffix 件
                .app-line
                  span.app-line-title 総箱数
                  span.app-line-text {{total_boxes|number}}
                  span.app-line-suffix 個
                .app-line
                  span.app-line-title 総重量
                  span.app-line-text {{grand_weight|number}}
                  span.app-line-suffix kg
                .app-line
                  span.app-line-title 送料
                  span.app-line-text {{summary.delivery_fee|number}}
                  span.app-line-suffix 円
                .app-line
                  span.app-line-title 原価計
                  span.app-line-text {{grand_cost|number}}
                  span.app-line-suffix 円
                .app-line
                  span.app-line-title 値引
                  span.app-line-text {{discountDisplayValue|number}}
                  span.app-line-suffix 円

          v-flex.pt-0(xs12 xl4)

            v-card.mt-1
              v-card-title.success
                | 見積/注文金額
              v-card-text
                div.ma-4.text-xs-right.success--text
                  span.rem36 {{grand_total|number}}
                  span.rem16.ml-2 円
                  v-divider.success
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import rules from '@/common/mixins/rules'
import _ from 'underscore'
import mathjs from 'mathjs'
import extend from 'extend'

export default {
  data () {
    return {}
  },
  mixins: [rules],
  created () {},
  computed: {
    ...mapGetters('app/order', [
      'order',
      'prepare',
      'boxes',
      'summary',
      'isListEmpty',
      'hasTrial',
      'totalRows'
    ]),
    total_rows () {
      return this.totalRows
    },
    total_boxes () {
      let total = 0
      _.each(this.boxes, function (box) {
        total += parseInt(box.input.overview.quantity, 10)
      })
      return total
    },
    grand_weight () {
      let total = 0
      _.each(this.boxes, function (box) {
        total = mathjs.add(total, box.weight.total)
      })
      return mathjs.ceil(total)
    },
    grand_cost () {
      let self = this
      let total = 0
      _.each(self.boxes, function (box) {
        total = mathjs.add(
          total,
          mathjs.ceil(
            mathjs
              .chain(box.summary.unit_cost)
              .multiply(box.input.overview.quantity)
              .done()
          )
        )
      })
      return total
    },
    discountDisplayValue () {
      return parseInt(this.summary.discount, 10) * -1
    },
    grand_total () {
      let self = this
      let total = 0
      _.each(self.boxes, function (box) {
        total = mathjs.add(total, box.summary.fixed_amount)
        _.each(box.input.appendices, function (appendix) {
          total = mathjs.ceil(mathjs.add(total, appendix.amount))
        })
      })
      return mathjs
        .chain(total)
        .add(self.summary.delivery_fee)
        .subtract(self.summary.discount)
        .done()
    }
  },
  methods: {
    ...mapActions('app/order', ['activateTab', 'setSummary']),
    closing () {
      let self = this
      if (self.hasRuleError()) {
        self.$toastr.warning(self.$t('_rules.invalidate_message'))
        return true
      }
      self.$toastr.info(self.$t('order.summary.save_order'))
      let tmp = extend(true, {}, self.order)
      let order = extend(true, tmp, {
        total_rows: self.total_rows,
        total_boxes: self.total_boxes,
        grand_weight: self.grand_weight,
        grand_cost: self.grand_cost,
        grand_total: self.grand_total
      })
      self.$ajax.post('order/estimate', order).then(function (response) {
        self.$toastr.success(self.$t('order.summary.saved_order'))
        let token = response.data.token
        self.$router.push({ name: 'order_reload', params: { token: token } })
      })
    },
    previewQuotation () {
      let self = this
      if (self.hasRuleError()) {
        self.$toastr.warning(self.$t('_rules.invalidate_message'))
        return true
      }
      self.$toastr.success(self.$t('order.summary.create_preview'))
      let order = extend(true, self.order, {
        total_rows: self.total_rows,
        total_boxes: self.total_boxes,
        grand_weight: self.grand_weight,
        grand_cost: self.grand_cost,
        grand_total: self.grand_total
      })
      let v = window.open()
      self.$ajax
        .post('order/preview_quotation', order)
        .then(function (response) {
          let uri = response.data.uri
          v.location.href = uri
        })
    }
  }
}
</script>

<style scoped lang="stylus"></style>



// WEBPACK FOOTER //
// src/app/pages/Order/Components/Summary.vue